/* eslint-disable no-async-promise-executor */
import { useExceptionStore } from "@/stores/exceptionStore";
import type { RequestType } from "@/types/common";
import { isAppException } from "@/utils/appUtil";
import { AppAuthTokenKey, LocaleKey } from "@/libs/constant";
import type { AxiosResponse } from "axios";
import { api } from "@/boot/axios";
import { Cookies } from "quasar";
export const usePreFetch = (ssrContext: any, redirect: any) => {
  const exceptionStore = useExceptionStore();

  const callAxios = async <T>(req: RequestType): Promise<T> => {
    return new Promise(async (resolve, reject) => {
      const response = await callAxiosProcess<T>(req);
      if (isAppException(response)) {
        exceptionStore.setException(response);
        redirect({ path: "/error" });
      }
      resolve(response.data as T);
    });
  };

  const callAxiosProcess = <T>(req: RequestType): Promise<AxiosResponse<T>> => {
    return new Promise((resolve, reject) => {
      if (!process.env.SERVER) {
        try {
          const locale = Cookies.get(LocaleKey);
          if (locale) {
            api.defaults.headers["Accept-Language"] = locale;
          }
          const token = Cookies.get(AppAuthTokenKey);
          if (token) {
            api.defaults.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.warn("Failed to get cookies on client:", error);
        }
      } else if (ssrContext) {
        try {
          const ck = Cookies.parseSSR(ssrContext);
          if (ck && typeof ck.get === "function") {
            const locale = ck.get(LocaleKey);
            if (locale) {
              api.defaults.headers["Accept-Language"] = locale;
            }
            const token = ck.get(AppAuthTokenKey);
            if (token) {
              api.defaults.headers.Authorization = `Bearer ${token}`;
            }
          }
        } catch (error) {
          console.warn("Failed to parse SSR cookies:", error);
        }
      }

      if (req.baseURL) {
        api.defaults.baseURL = req.baseURL;
      } else {
        if (process.env.SERVER) {
          api.defaults.baseURL = import.meta.env.VITE_API_BASE_URL_SSR || "";
        } else {
          api.defaults.baseURL = import.meta.env.VITE_API_BASE_URL || "";
        }
      }
      if (process.env.NODE_ENV == "development") {
        console.log(`usePrefecth > api ${api.defaults.baseURL}${req.API}`);
      }
      api({
        method: req.method,
        url: req.API,
        data: req.body ? req.body : undefined
      })
        .then(response => {
          resolve(response as AxiosResponse<T>);
        })
        .catch(error => {
          exceptionStore.setException({
            statusCode: error.code,
            message: error.message
          });
          const exeption: any = {
            statusCode: error.code,
            message: error.message,
            errors: "Error"
          };
          resolve(exeption);
        });
    });
  };

  return {
    callAxios,
    callAxiosProcess
  };
};
